import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import referral_45global from "/app/middleware/referral.global.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  referral_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}